import React from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/styles';
import { Field, reduxForm } from 'redux-form';
import { Col, FormGroup } from 'reactstrap';
import Button from 'components/buttons/Button';
import RenderSwitchInput from 'components/forms/RenderSwitchInput';

const styles = theme => ({
  label: {
    color: theme.palette.secondary.text,
    fontSize: '0.875rem',
    marginTop: '0.75rem',
  },
  permissionsForm: {
    display: 'flex',
    flexWrap: 'wrap',
    marginRight: '-15px',
    marginLeft: '-15px',
    alignItems: 'center',
  },
});

const PermissioningForm = (props) => {
  const { classes } = props;
  return (
    <form onSubmit={props.handleSubmit}>
      <div className={classes.permissionsForm}>
        <Col lg={6} xl={5}>
          <FormGroup row>
            {/* eslint-disable jsx-a11y/label-has-for */}
            <label className={`${classes.label} col-sm-3`}>Inbox Visible</label>
            <Col sm={7} className="switch--vert-center">
              {/* eslint-disable jsx-a11y/label-has-for */}
              <label htmlFor="inbox_visible">
                {/* eslint-enable jsx-a11y/label-has-for */}
                <Field
                  maxLength="255"
                  id="inbox_visible"
                  name="inbox_visible"
                  component={RenderSwitchInput}
                />
              </label>
            </Col>
          </FormGroup>
        </Col>
        <Col lg={6} xl={5}>
          <FormGroup row>
            {/* eslint-disable jsx-a11y/label-has-for */}
            <label className={`${classes.label} col-sm-3`}>Client can reply to and forward emails</label>
            <Col sm={7} className="switch--vert-center">
              {/* eslint-disable jsx-a11y/label-has-for */}
              <label htmlFor="client_manages_replies">
                {/* eslint-enable jsx-a11y/label-has-for */}
                <Field
                  maxLength="255"
                  id="client_manages_replies"
                  name="client_manages_replies"
                  component={RenderSwitchInput}
                />
              </label>
            </Col>
          </FormGroup>
        </Col>
      </div>
      <Button
        disabled={props.pristine || props.submitting}
        color="secondary"
        variant="outlined"
        type="submit"
      >
        Save
      </Button>
    </form>
  );
};


PermissioningForm.propTypes = {
  classes: PropTypes.element.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
  pristine: PropTypes.bool,
};


PermissioningForm.defaultProps = {
  submitting: false,
  pristine: true,
};


export default compose(
  withStyles(styles),
  connect(
    state => ({
      initialValues: {
        inbox_visible: state.account.inbox_visible,
        client_manages_replies: state.account.client_manages_replies,
      },
    }),
    { },
  ),
  reduxForm({
    form: 'permissioningForm',
    enableReinitialize: true,
  }),
)(PermissioningForm);
